



































import { Vue, Component } from 'vue-property-decorator'
import { Getter, Mutation, State, Action } from 'vuex-class'
import { RootState } from '@/store/types'
import { UISize } from '@/store/ui/types'
import { isElectron } from '@/util/Helpers'
import { INITIAL_CONNECT } from '@/store/ui/constants'
import AccountDropdown from './AccountDropdown.vue'

@Component({ name: 'side-panel-header', components: { AccountDropdown } })
export default class SidePanelHeader extends Vue {
    @Action(INITIAL_CONNECT)
    initialConnect!: () => Promise<void>

    /**
     * The size of the app
     */
    @State((state: RootState) => state.ui.size)
    uiSize!: UISize

    /**
     * If the application is connected to the server
     */
    @State((state: RootState) => state.ui.isOnline)
    isOnline!: boolean

    /**
     * Whether the tree can be toggled (based on UI size)
     */
    @Getter
    canToggleTree!: boolean

    /**
     * Whether the current UI size is mobile
     */
    @Getter
    usingPages!: boolean

    isElectron(): boolean {
        return isElectron()
    }
}
